// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1982":"css/app.7064","3834":"css/admin-app.7064"}[chunkId] + ".css";
};